import type { Feature } from "../types";

/** Apresentação da editorial: texto à esquerda, fotografia à direita. */
export const editorialFeature: Feature = {
	id: "editorial",
	kicker: "l’editorial",
	lead: "Cosa Nova 17488 és un espai de trobada, de diàleg i de descoberta.",
	paragraphs: [
		"Som una editorial independent amb seu a Cadaqués, nascuda amb la voluntat d’unir literatura, territori i recerques en l’àmbit cultural.",
		"Comencem amb un equip petit, però ambiciós, convençut del poder dels llibres per traduir mons, generar diàleg intercultural i crear experiències que transcendeixen la lectura.",
	],
	cta: { label: "coneix l’equip", href: "/qui-som/" },
	photo: {
		src: "/assets/hero.webp",
		alt: "Cadaqués vist des de dalt, amb l’església de Santa Maria sobre les teulades.",
		credit: "Fotografia d’Andrea Resmini",
	},
};

/** Llançament de Pur: lados invertidos, para dar movimento à página. */
export const presentationFeature: Feature = {
	id: "presentacio",
	kicker: "llançament",
	lead: "Acompanya’ns en el llançament de Pur, de Nara Vidal.",
	paragraphs: [
		"«La ciutat es diu Santa Graça —referència de virtut i netedat en el territori nacional.»",
		"El Brasil dels anys 30 es converteix en el laboratori d’una eugenèsia cruel disfressada de ciència. Amb un to directe i desafiador, Nara Vidal teixeix una estructura a diverses veus marcada pel xoc sense concessions entre què diuen, què pensen i què fan els personatges. Pur ha estat guardonada amb el reconegut Premi APCA 2024 a la millor novel·la brasilera, i traduïda a l’anglès i al francès. Una obra profundament impactant on fons i forma s’alien en una narrativa incòmoda que esdevé reflex de geografies i temps més propers i presents del que voldríem creure.",
	],
	cta: {
		label: "Vull saber-ne més",
		href: "/producte/pur-nara-vidal/",
	},
	photo: {
		src: "/assets/pur-presentacio.jpg",
		alt: "Coberta del llibre Pur, de Nara Vidal.",
	},
	reversed: true,
};
